<template>
    <div class="select-project-prompt">
      <img :src="imageUrl" alt="Select Project" class="prompt-image" />
      <p class="prompt-text">Select a project from the sidebar to continue.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SelectProjectPrompt',
    data() {
      return {
        imageUrl: require('@/assets/image.svg'), // Corrected image path using require()
      };
    }
  };
  </script>
  
  <style scoped>
  .select-project-prompt {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 100vh; /* Full height to prevent overlap */
    padding: 20px;
    border: 1px dashed #ccc; /* Optional: Add a border for visual separation */
    border-radius: 8px;
    background-color: #fff; /* Ensure it doesn't get transparent */
    flex-grow: 1; /* Expands to fill available space */
  }
  
  .prompt-image {
    max-width: 200px; /* Adjust the size as needed */
    height: auto;
    margin-bottom: 15px;
  }
  
  .prompt-text {
    font-size: 1.2em;
    color: #777;
  }
  
  /* Ensure the container has full width inside a flex parent */
  html, body, #app {
    height: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
  }
  </style>
  